import * as React from 'react'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { cn } from '../../lib/utils.js'
import PropTypes from 'prop-types'

const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
    return (<RadioGroupPrimitive.Root className={cn('grid gap-2', className)} {...props} ref={ref} />)
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef(({ className, ...props }, ref) => {
    return (
        (<RadioGroupPrimitive.Item
            ref={ref}
            className={cn(
                'aspect-square h-4 w-4 rounded-full border border-primary text-primary shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
                className
            )}
            {...props}>
            <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
                <span className="radio-indicator" />
            </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>)
    )
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

RadioGroupItem.propTypes = {
    className: PropTypes.string
}

RadioGroup.propTypes = {
    className: PropTypes.string
}

export { RadioGroup, RadioGroupItem }
